import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, Typography } from '@material-ui/core';

import { useStyles } from "./styles";

const PageNotFound: FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.pageNotFoundContainer}>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item sm={12} md={5}>
                    <Typography variant="h1" component="h1" className={classes.errorCode}>
                        404
                    </Typography>
                </Grid>
                <div className={classes.verticalDivider}></div>
                <Grid item sm={12} md={5} className={classes.informationContainer}>
                    <p style={{fontWeight:'bolder'}}>
                        ¡Página no encontrada!
                    </p>
                    <p style={{fontWeight:'lighter'}}>
                        Lamentamos el inconveniente. Parece ser que estás accediendo a una página que no existe o no tienes las credenciales necesarias para acceder.
                    </p>
                </Grid>
                <Grid item sm={12} md={12} className={classes.homeContainer}>
                    <Button component={Link} to="/" variant="contained" className={classes.homeButton}>
                        Ir a inicio
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}

export default PageNotFound;
